import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 31 32"
    {...props}
  >
    <path
      d="M14 16C16.1217 16 18.1566 15.1571 19.6569 13.6569C21.1571 12.1566 22 10.1217 22 8C22 5.87827 21.1571 3.84344 19.6569 2.34315C18.1566 0.842855 16.1217 0 14 0C11.8783 0 9.84344 0.842855 8.34315 2.34315C6.84286 3.84344 6 5.87827 6 8C6 10.1217 6.84286 12.1566 8.34315 13.6569C9.84344 15.1571 11.8783 16 14 16Z"
      fill="currentColor"
    />
    <path
      d="M26.4615 10.3474V21.1166C26.4615 21.4565 26.7371 21.732 27.0769 21.732H29.8462C30.186 21.732 30.4615 21.4565 30.4615 21.1166V10.3474C30.4615 10.0075 30.186 9.73197 29.8462 9.73197H27.0769C26.7371 9.73197 26.4615 10.0075 26.4615 10.3474Z"
      fill="currentColor"
    />
    <path
      d="M26.4615 26.3474V29.1166C26.4615 29.4565 26.7371 29.732 27.0769 29.732H29.8462C30.186 29.732 30.4615 29.4565 30.4615 29.1166V26.3474C30.4615 26.0075 30.186 25.732 29.8462 25.732H27.0769C26.7371 25.732 26.4615 26.0075 26.4615 26.3474Z"
      fill="currentColor"
    />
    <path
      d="M11.1438 19C4.9875 19 0 23.9875 0 30.1438C0 31.1688 0.83125 32 1.85625 32H22.7827V31.9914C22.7546 31.9859 22.7264 31.9781 22.7827 31.9688V19H11.15H11.1438Z"
      fill="currentColor"
    />
  </svg>
);
const IconUserExclamation = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconUserExclamation;
